import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./LinksContainer.module.css";

function LinksContainer({ title, links }) {
  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>{title}</h2>
      <ul className={styles["list-style"]}>
        {links.map((item) => (
          <li key={item.id}>
            <NavLink to={item.url} className={styles["link"]}>
              {item.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LinksContainer;
